const thunderforestKey = process.env.REACT_APP_THUNDERFOREST_KEY;
export const mapTileUrlList = {
    default: 'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
    googleMaps: 'https://mt1.google.com/vt/lyrs=y&hl=fa&x={x}&y={y}&z={z}',
    googleMapsRoads: 'https://mt1.google.com/vt/lyrs=h&hl=fa&x={x}&y={y}&z={z}',
    googleMapsSatellite: 'https://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}',
    googleMapsHybrid: 'https://mt1.google.com/vt/lyrs=y&hl=fa&x={x}&y={y}&z={z}',
    bingMapSatellite: 'bing',
    arcGIS: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    openStreetMap: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    openStreetMap2: 'https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png',
    openStreetTopography: 'https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png',
    stadiaMap: 'https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png',
    thunderForestTopography: `https://tile.thunderforest.com/cycle/{z}/{x}/{y}.png?apikey=${thunderforestKey}`,
    topographyMap: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
    wikiMediaMap: 'https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png',
};
